module.exports = __webpack_public_path__ + "static/fonts/Gibson-Regular.woff";